<ul class="navbar-nav ms-auto">
    <li>
        <div class="tenant-switcher" *ngIf="isSuperAdmin && tenants.length">
            <select class="form-select" [(ngModel)]="selectedTenantId" (ngModelChange)="onTenantChange($event)">
                <option *ngFor="let tenant of tenants" [ngValue]="tenant.id">
                    {{ tenant.name }}
                </option>
            </select>
        </div>
    </li>

    <li>
        <a href="javascript:" (click)="toggleFullscreen()">
            <i class="feather" [ngClass]="screenFull ? 'icon-minimize' : 'icon-maximize'"></i>
        </a>
    </li>

    <!-- Notification Bell — uses NgbDropdown for responsive positioning & click-outside handling -->
    <li class="wo-notif-bell-li" ngbDropdown placement="bottom-end bottom-start auto"
        (openChange)="onNotifDropdownChange($event)">
        <a href="javascript:" class="wo-notif-bell-btn" ngbDropdownToggle id="notification-bell-btn"
            title="Notifications" aria-label="Notifications">
            <i class="feather icon-bell"></i>
            @if (notificationService.unreadCount() > 0) {
            <span
                class="wo-notif-badge">{{ notificationService.unreadCount() > 99 ? '99+' : notificationService.unreadCount() }}</span>
            }
        </a>
        <div class="wo-notif-dropdown dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <div class="wo-notif-header">
                <span class="wo-notif-title">Notifications</span>
                @if (notificationService.unreadCount() > 0) {
                <span class="wo-notif-unread-count-tag">{{ notificationService.unreadCount() }} new</span>
                }
            </div>
            <div class="wo-notif-body">
                @if (notificationService.notifications().length === 0) {
                <div class="wo-notif-empty">
                    <i class="feather icon-bell-off"></i>
                    <span>No notifications yet</span>
                </div>
                }
                @for (notif of notificationService.notifications(); track notif.id) {
                <div class="wo-notif-item" [class.wo-notif-unread]="!notif.is_read"
                    (click)="onNotificationClick(notif)">
                    <div class="wo-notif-dot" [class.visible]="!notif.is_read"></div>
                    <div class="wo-notif-content">
                        <p class="wo-notif-msg">{{ notif.message }}</p>
                        <span class="wo-notif-time">{{ notif.created_at | date:'MMM d, h:mm a' }}</span>
                    </div>
                </div>
                }
            </div>
        </div>
    </li>

    <li class="notification-bell-item">
        <app-notification-bell></app-notification-bell>
    </li>


    <li>
        <div class="dropdown drp-user" ngbDropdown placement="auto">
            <a href="javascript:" ngbDropdownToggle>
                <img src="assets/dev_images/auth/dummy-profile-pic-1.jpg" class="img-radius wid-40"
                    alt="User-Profile-Image" />
            </a>
            <div class="dropdown-menu dropdown-menu-end profile-notification" ngbDropdownMenu>
                <div class="pro-head">
                    <img src="assets/dev_images/auth/dummy-profile-pic-1.jpg" class="img-radius"
                        alt="User-Profile-Image" />
                    <span>{{ this.authenticationService.currentUserName }}</span>
                    <a href="javascript:" class="dud-logout" title="Logout" (click)="logout()">
                        <i class="feather icon-log-out"></i>
                    </a>
                </div>

                <ul class="pro-body">
                    <!-- <li>
            <a href="javascript:" class="dropdown-item">
              <i class="feather icon-user"></i>
              Profile
            </a>
          </li>
          <li>
            <a href="javascript:" class="dropdown-item">
              <i class="feather icon-mail"></i>
              My Messages
            </a>
          </li>
          <li>
            <a href="javascript:" class="dropdown-item">
              <i class="feather icon-lock"></i>
              Lock Screen
            </a>
          </li> -->
                    <li *ngIf="role !== 'user'">
                        <a href="javascript:" class="dropdown-item" (click)="subscription()">
                            <i class="feather icon-package"></i>
                            Subscriptions
                        </a>
                    </li>
                    <li>
                        <a href="javascript:" class="dropdown-item" (click)="logout()">
                            <i class="feather icon-lock"></i>
                            Logout
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</ul>

@if (visibleUserList && direction === 'ltr') {
<section class="header-user-list" [ngClass]="{ open: visibleUserList }" [@slideInOutLeft]>
    <app-chat-user-list (ChatToggle)="onChatToggle($event)"
        (ChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false" />
</section>
}
@if (chatMessage && direction === 'ltr') {
<section class="header-chat" [ngClass]="{ open: chatMessage }" [@slideInOutLeft]>
    <app-chat-msg (ChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId" />
</section>
}
@if (visibleUserList && direction === 'rtl') {
<section class="header-user-list" [ngClass]="{ open: visibleUserList }" [@slideInOutRight]>
    <app-chat-user-list (ChatToggle)="onChatToggle($event)"
        (ChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false" />
</section>
}
@if (chatMessage && direction === 'rtl') {
<section class="header-chat" [ngClass]="{ open: chatMessage }" [@slideInOutRight]>
    <app-chat-msg (ChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId" />
</section>
}


